import { useState, useEffect } from 'react';
import '../styles/InactivityWarningModal.css';

function InactivityWarningModal({ secondsRemaining, onStayLoggedIn }) {
    const [seconds, setSeconds] = useState(secondsRemaining);

    useEffect(() => {
        setSeconds(secondsRemaining);
    }, [secondsRemaining]);

    useEffect(() => {
        if (seconds <= 0) return;
        const interval = setInterval(() => {
            setSeconds(s => Math.max(0, s - 1));
        }, 1000);
        return () => clearInterval(interval);
    }, [seconds]);

    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const display = minutes > 0
        ? `${minutes}:${secs.toString().padStart(2, '0')}`
        : `${secs}s`;

    return (
        <div className="inactivity-modal-overlay">
            <div className="inactivity-modal">
                <div className="inactivity-icon">&#9201;</div>
                <h2>Session Timeout Warning</h2>
                <p>
                    You'll be logged out in <strong>{display}</strong> due to inactivity.
                </p>
                <button className="inactivity-stay-button" onClick={onStayLoggedIn}>
                    Stay Logged In
                </button>
            </div>
        </div>
    );
}

export default InactivityWarningModal;
